/* utm.js — Capture UTM/click ID parameters and persist them across the funnel.
   Captured on first landing, stored in localStorage, attached automatically
   to any lead creation, and available everywhere via getUtm().
*/

const KEY = "dz_utm";
const EXPIRY_DAYS = 30;
const FIELDS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "gclid",
  "fbclid",
];

export function captureUtmFromUrl() {
  try {
    const sp = new URLSearchParams(window.location.search);
    const captured = {};
    for (const f of FIELDS) {
      const v = sp.get(f);
      if (v) captured[f] = v;
    }
    if (Object.keys(captured).length === 0) return null;
    const entry = {
      ...captured,
      landing_page: window.location.pathname,
      referrer: document.referrer || null,
      captured_at: new Date().toISOString(),
    };
    localStorage.setItem(KEY, JSON.stringify(entry));
    return entry;
  } catch {
    return null;
  }
}

export function getUtm() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    // Expire stale UTMs so old campaigns don't leak into new conversions
    if (data?.captured_at) {
      const age = Date.now() - new Date(data.captured_at).getTime();
      if (age > EXPIRY_DAYS * 24 * 60 * 60 * 1000) {
        localStorage.removeItem(KEY);
        return null;
      }
    }
    return data;
  } catch {
    return null;
  }
}

export function clearUtm() {
  try { localStorage.removeItem(KEY); } catch {}
}
